import type { XWebViewProps } from '~/components/source-viewer/types'

export default function WebView({ source, onLoad, onError, className }: XWebViewProps) {
  return (
    <iframe
      key={source}
      // eslint-disable-next-line i18next/no-literal-string
      title="source"
      src={source}
      onLoad={onLoad}
      onError={onError}
      allowFullScreen={false}
      sandbox="allow-same-origin allow-scripts"
      referrerPolicy="no-referrer"
      height="100%"
      width="100%"
      className={className}
      frameBorder="0"
    />
  )
}
